import React from "react";

export default function UsecasesContent() {
    
    return(
        <>
        </>
    );
}